import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/*
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
*/

import common_en from "./app/core/translations/en/common.json";
import signin_en from "./app/core/translations/en/signin.json";
import error_en from "./app/core/translations/en/error.json";
//import common_de from "./app/core/translations/de/common.json";
import vpa_common_en from "./app/voice-admin/pages/common/translations/en/common.json";
import vpa_navbar_en from "./app/voice-admin/pages/common/translations/en/navbar.json";
import vpa_home_en from "./app/voice-admin/pages/common/translations/en/home.json";
import vpa_voicesetup_en from "./app/voice-admin/pages/voice-setup/translations/en/voice-setup.json";
import vpa_routing_en from "./app/voice-admin/pages/routing/translations/en/routing.json";
import vpa_users_en from "./app/voice-admin/pages/users/translations/en/users.json";
import vpa_servicenumbers_en from "./app/voice-admin/pages/service-numbers/translations/en/service-numbers.json";
import vpa_domainsetup_en from "./app/voice-admin/pages/domain-setup/translations/en/domain-setup.json";
import vpa_number_inventory_en from "./app/voice-admin/pages/inventory/translations/en/number-inventory.json"
import vpa_number_order_en from "./app/voice-admin/pages/inventory/translations/en/number-order.json";
import vpa_subscriber_address_en from "./app/voice-admin/pages/inventory/translations/en/subscriber-address.json";
import vpa_number_types_en from "./app/voice-admin/pages/admin-config/translations/en/number-types.json";
import vpa_departments_en from "./app/voice-admin/pages/admin-config/translations/en/departments.json";
import vpa_carriers_en from "./app/voice-admin/pages/admin-config/translations/en/carriers.json";
import vpa_device_types_en from "./app/voice-admin/pages/admin-config/translations/en/device-types.json";


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        common: common_en,
        signin: signin_en,
        error: error_en,
        vpa_common: vpa_common_en,
        vpa_navbar: vpa_navbar_en,
        vpa_home: vpa_home_en,
        vpa_voicesetup: vpa_voicesetup_en,
        vpa_routing: vpa_routing_en,
        vpa_users: vpa_users_en,
        vpa_servicenumbers: vpa_servicenumbers_en,
        vpa_domainsetup: vpa_domainsetup_en,
        vpa_number_inventory: vpa_number_inventory_en,
        vpa_number_order: vpa_number_order_en,
        vpa_subscriber_address: vpa_subscriber_address_en,
        vpa_numbertypes: vpa_number_types_en,
        vpa_departments: vpa_departments_en,
        vpa_carriers: vpa_carriers_en,
        vpa_devicetypes: vpa_device_types_en
      },
      /*
      de: {
        common: common_de,
      },
      */
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
